const SET_ORDER = "SET_ORDER";
const INIT_ORDER = "INIT_ORDER";

export function setOrder(payload) {
  return {
    type: SET_ORDER,
    payload,
  };
}

export function initOrder() {
  return {
    type: INIT_ORDER,
    payload: {},
  };
}

const INIT_STATE = {
  order: {},
};

export default function OrdersDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case SET_ORDER:
      newState.order = action.payload;
      break;
    case INIT_ORDER:
      newState.order = {};
      break;
    default:
      break;
  }
  return newState;
}
